import PropTypes from 'prop-types'
import React, { Component } from 'react'
import { connect } from 'react-redux'
import Error404 from 'components/errors/404'
import { setLanguage } from 'actions'
import { fetchCandidate } from 'interview/actions/candidate'
import FetchWithSpinner from 'components/fetch-with-spinner'
import Layout from 'interview/components/layout'

const propTypes = {
  httpError: PropTypes.number,
  dispatch: PropTypes.func.isRequired,
  location: PropTypes.shape({}).isRequired,
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
  ]),
  params: PropTypes.shape({}).isRequired,
}

const defaultProps = {
  children: undefined,
  httpError: undefined,
}

export class SequencedInterviewPage extends Component {
  componentDidMount() {
    const {
      dispatch,
      location: {
        query: { lang },
      },
    } = this.props
    if (lang) {
      dispatch(setLanguage(lang))
    }
  }

  render() {
    const { params, children, httpError } = this.props
    if (httpError === 404) {
      return <Error404 />
    }
    return (
      <FetchWithSpinner
        action={() => fetchCandidate(params, 'sequenced-interview')}
      >
        <Layout size="small" hideLogo>
          {children}
        </Layout>
      </FetchWithSpinner>
    )
  }
}

SequencedInterviewPage.propTypes = propTypes
SequencedInterviewPage.defaultProps = defaultProps

export default connect()(SequencedInterviewPage)
